// extracted by mini-css-extract-plugin
export var container = "styles-module--container--hk7KD";
export var titleContainer = "styles-module--title-container--1Lzif";
export var title = "styles-module--title--84ILA";
export var description = "styles-module--description--OMT-b";
export var thumbnailContainer = "styles-module--thumbnail-container--SxVjv";
export var thumbnail = "styles-module--thumbnail--BjfSN";